export default __webpack_public_path__ + "static/media/seademo_infografica_en.3dbea3fb.jpg";